export default [
    {
      path: '/artist/vidcents-wallet',
      name: 'VidCents Wallet',
      component: () =>
        import(/* webpackChunkName: 'vidcents-wallet-artist' */ './views/Index.vue')
    }
  ]
  